import { FormControl, FormGroup, Validators } from "@angular/forms";
import { InsoleComponentValidators } from "./insole-component-validator";

export type InsoleComponentsGroups = "shellModifications" | "accomodations" | "postings";

export interface InsoleComponent {
    title: string,
    translationKey: string,
    imageUrl: string,
    footSelectionOptions: { value: string, title: string, translationKey: string, disabled: boolean }[],
    selectOptions?: { value: any, title: string }[],
    medialLateralType?: "unique" | "multiple",
    reversedBooleanOption?: boolean,
    typeSelectOptions?: { value: any, title: string }[],
    group: InsoleComponentsGroups,
    form: FormGroup
}

export class ValueNumberFormGroup extends FormGroup {
    constructor(initialValue?: number) {
        super({
            value: new FormControl(initialValue, { nonNullable: true })
        });
    }
}

export class ValueBooleanFormGroup extends FormGroup {
    constructor(initialValue?: boolean) {
        super({
            value: new FormControl(initialValue, { nonNullable: true })
        });
    }
}

export class ValueNumberWithSelectionFormGroup extends FormGroup {
    constructor(initialValue?: number, initialSelectedName?: string, initialType?: string | null) {
        super({
            value: new FormControl(initialValue, { nonNullable: true }),
            selectedName: new FormControl(initialSelectedName, { nonNullable: true }),
            type: new FormControl(initialType, { nonNullable: true })
        });
    }
}

export class ValueNumberWithSelectionWidthHeightFormGroup extends FormGroup {
    constructor(initialValue?: number, initialSelectedName?: string) {
        super({
            width: new ValueNumberWithSelectionFormGroup(),
            height: new ValueNumberWithSelectionFormGroup()
        });
    }
}

export class ValueNumberWithSelectionAndDegreeFormGroup extends FormGroup {
    constructor(initialValue?: number | null, initialSelectedName?: string | null, initialDegree?: number | null) {
        super({
            value: new FormControl(initialValue, { nonNullable: true }),
            selectedName: new FormControl(initialSelectedName, { nonNullable: true }),
            degree: new FormControl(initialDegree, { nonNullable: true }),

        });
    }
}

export class ValueNumberWithSelectionAndTypeFormGroup extends FormGroup {
    constructor(initialValue?: number | null, initialSelectedName?: string | null, initialType?: string | null) {
        super({
            value: new FormControl(initialValue, { nonNullable: true }),
            selectedName: new FormControl(initialSelectedName, { nonNullable: true }),
            type: new FormControl(initialType, { nonNullable: true })
        });
    }
}

export class ValueNumberWithSelectionAndBalanceToRearfootFormGroup extends FormGroup {
    constructor(initialValue?: number, initialSelectedName?: string) {
        super({
            value: new FormControl(initialValue, { nonNullable: true }),
            selectedName: new FormControl(initialSelectedName, { nonNullable: true }),
            balancedToRearfoot: new FormControl(false, { nonNullable: true }),
            filled: new FormControl(false, { nonNullable: true })
        });
    }
}

export class ValueNumberWithSelectionAndExtrinsicFormGroup extends FormGroup {
    constructor(initialValue?: number, initialSelectedName?: string) {
        super({
            value: new FormControl(initialValue, { nonNullable: true }),
            selectedName: new FormControl(initialSelectedName, { nonNullable: true }),
            extrinsic: new FormControl(false, { nonNullable: true })
        });
    }
}

export class LateralMedialWithSelectionNameFormGroup extends FormGroup {
    constructor(initialValue?: number, initialSelectedName?: string) {
        super({
            lateral: new ValueNumberWithSelectionFormGroup(),
            medial: new ValueNumberWithSelectionFormGroup(),
        });
    }
}

export class LateralMedialWithSelectionNameAndWidthHeightFormGroup extends FormGroup {
    constructor(initialValue?: number, initialSelectedName?: string) {
        super({
            lateral: new ValueNumberWithSelectionWidthHeightFormGroup(),
            medial: new ValueNumberWithSelectionWidthHeightFormGroup(),
        });
    }
}

export class LateralMedialWithSelectionNameAndPositionFormGroup extends FormGroup {
    constructor(initialValue?: number, initialSelectedName?: string) {
        super({
            position: new FormControl('medial', { nonNullable: true }),
            lateral: new ValueNumberWithSelectionFormGroup(),
            medial: new ValueNumberWithSelectionFormGroup(),
        });
    }
}

export class LateralMedialWithSelectionNamePositionAndBalancedToRearfoot extends FormGroup {
    constructor(initialValue?: number, initialSelectedName?: string) {
        super({
            position: new FormControl('medial', { nonNullable: true }),
            lateral: new ValueNumberWithSelectionFormGroup(),
            medial: new ValueNumberWithSelectionFormGroup(),
        });
    }
}

export class ReversedBooleanRigidityString extends FormGroup {
    constructor(initialValue?: number, initialSelectedName?: string) {
        super({
            value: new FormControl(initialValue, { nonNullable: true }),
            selectedName: new FormControl(initialSelectedName, { nonNullable: true }),
            reversed: new FormControl(false, { nonNullable: true }),
            rigidity: new FormControl('rigid', { nonNullable: true }),
        });
    }
}

export class PositionDensityReduction extends FormGroup {
    constructor(initialValue?: number, initialSelectedName?: string) {
        super({
            position: new FormGroup(
                {
                    heel: new FormControl(false, { nonNullable: true }),
                    medialArch: new FormControl(false, { nonNullable: true }),
                    lateralArch: new FormControl(false, { nonNullable: true }),
                    metatarsal: new FormControl(false, { nonNullable: true }),
                }
            )
        });
    }
}


export const insoleComponentsForms = {
    heelcup: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl('heelCup', { nonNullable: true }),
        left: new ValueNumberWithSelectionFormGroup(),
        right: new ValueNumberWithSelectionFormGroup()
    }, { validators: InsoleComponentValidators.footSelectionValidator }),
    kirbySkive: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl('kirbySkive', { nonNullable: true }),
        left: new LateralMedialWithSelectionNameAndPositionFormGroup(),
        right: new LateralMedialWithSelectionNameAndPositionFormGroup()
    }, { validators: InsoleComponentValidators.positionMedialLateralValidator }),
    firstRayCutout: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl('firstRayCutout', { nonNullable: true }),
        left: new ValueNumberWithSelectionAndDegreeFormGroup(null, null, 60),
        right: new ValueNumberWithSelectionAndDegreeFormGroup(null, null, 60)
    }, { validators: InsoleComponentValidators.footSelectionValidator }),
    flanges: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl("flanges", { nonNullable: true }),
        left: new LateralMedialWithSelectionNameAndWidthHeightFormGroup(),
        right: new LateralMedialWithSelectionNameAndWidthHeightFormGroup()
    }, { validators: InsoleComponentValidators.medialLateralWidthHeightAtLeastOneValidator }),
    archModification: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl("archModification", { nonNullable: true }),
        left: new LateralMedialWithSelectionNameFormGroup(),
        right: new LateralMedialWithSelectionNameFormGroup()
    }, { validators: InsoleComponentValidators.medialLateralAtLeastOneValidator }),
    archReinforcement: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl("archReinforcement", { nonNullable: true }),
        left: new ValueNumberWithSelectionFormGroup(),
        right: new ValueNumberWithSelectionFormGroup(),
    }, { validators: InsoleComponentValidators.footSelectionValidator }),
    mortonsExtension: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl("mortonsExtension", { nonNullable: true }),
        left: new ReversedBooleanRigidityString(),
        right: new ReversedBooleanRigidityString()
    }),
    cutout: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl("cutout", { nonNullable: true }),
        left: new ValueBooleanFormGroup(true),
        right: new ValueBooleanFormGroup(true)
    }),
    forefootPosting: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl("forefootPosting", { nonNullable: true }),
        left: new FormGroup({
            position: new FormControl("medial", { nonNullable: true }),
            lateral: new ValueNumberWithSelectionAndBalanceToRearfootFormGroup(),
            medial: new ValueNumberWithSelectionAndBalanceToRearfootFormGroup()
        }),
        right: new FormGroup({
            position: new FormControl("medial", { nonNullable: true }),
            lateral: new ValueNumberWithSelectionAndBalanceToRearfootFormGroup(),
            medial: new ValueNumberWithSelectionAndBalanceToRearfootFormGroup()
        })
    }, { validators: InsoleComponentValidators.positionMedialLateralValidator }),
    rearfootPosting: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl("rearfootPosting", { nonNullable: true }),
        left: new FormGroup({
            type: new FormControl("uShape", { nonNullable: true }),
            position: new FormControl("medial", { nonNullable: true }),
            lateral: new ValueNumberWithSelectionAndExtrinsicFormGroup(),
            medial: new ValueNumberWithSelectionAndExtrinsicFormGroup(),
        }),
        right: new FormGroup({
            type: new FormControl("uShape", { nonNullable: true }),
            position: new FormControl("medial", { nonNullable: true }),
            lateral: new ValueNumberWithSelectionAndExtrinsicFormGroup(),
            medial: new ValueNumberWithSelectionAndExtrinsicFormGroup(),
        })
    }, { validators: InsoleComponentValidators.positionMedialLateralValidator }),
    metatarsalPad: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl("metatarsalPad", { nonNullable: true }),
        left: new ValueNumberWithSelectionAndTypeFormGroup(null, null, "drop"),
        right: new ValueNumberWithSelectionAndTypeFormGroup(null, null, "drop"),
    }, { validators: InsoleComponentValidators.footSelectionValidator }),
    fascialGroove: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl("fascialGroove", { nonNullable: true }),
        left: new ValueBooleanFormGroup(true),
        right: new ValueBooleanFormGroup(true)
    }),
    styloid: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl("styloid", { nonNullable: true }),
        left: new ValueNumberWithSelectionFormGroup(),
        right: new ValueNumberWithSelectionFormGroup()
    }, { validators: InsoleComponentValidators.footSelectionValidator }),
    navicularDepression: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl("navicularDepression", { nonNullable: true }),
        left: new ValueNumberWithSelectionFormGroup(),
        right: new ValueNumberWithSelectionFormGroup()
    }, { validators: InsoleComponentValidators.footSelectionValidator }),
    densityReduction: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl("densityReduction", { nonNullable: true }),
        left: new PositionDensityReduction(),
        right: new PositionDensityReduction()
    }),
    heelLift: new FormGroup({
        footSelection: new FormControl(null),
        type: new FormControl("heelLift", { nonNullable: true }),
        left: new ValueNumberWithSelectionAndTypeFormGroup(null, null, "uShape"),
        right: new ValueNumberWithSelectionAndTypeFormGroup(null, null, "uShape")
    }, { validators: InsoleComponentValidators.footSelectionValidator }),
};

let footSelectionOptions: { value: string, title: string, translationKey: string, disabled: boolean }[] = [
    {
        value: "left",
        title: "Left",
        translationKey: "FOOT_SELECTION.LEFT",
        disabled: false,
    },
    {
        value: "right",
        title: "Right",
        translationKey: "FOOT_SELECTION.RIGHT",
        disabled: false,
    },
    {
        value: "both",
        title: "Both",
        translationKey: "FOOT_SELECTION.BOTH",
        disabled: false,
    }
]


export let insoleComponentesConfig: InsoleComponent[] = [
    {
        title: "Heel Cup",
        translationKey: "INSOLE_COMPONENT.HEEL_CUP",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/heel_cup.png",
        group: "shellModifications",
        footSelectionOptions: footSelectionOptions,
        selectOptions: [
            {
                value: "others",
                title: "Others"
            },
            {
                value: 6,
                title: "6 mm",
            },
            {
                value: 12,
                title: "12 mm"
            },
            {
                value: 15,
                title: "15 mm"
            }
        ],
        form: insoleComponentsForms.heelcup
    },
    {
        title: "Kirby skive",
        translationKey: "INSOLE_COMPONENT.KIRBY_SKIVE",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/kirby_skive.png",
        group: "shellModifications",
        footSelectionOptions: footSelectionOptions,
        selectOptions: [
            {
                value: "others",
                title: "Others"
            },
            {
                value: 2,
                title: "2 mm",
            },
            {
                value: 4,
                title: "4 mm"
            },
            {
                value: 6,
                title: "6 mm"
            },
            {
                value: 8,
                title: "8 mm"
            }
        ],
        medialLateralType: "unique",
        form: insoleComponentsForms.kirbySkive
    },
    {
        title: "1st Ray Coutout",
        translationKey: "INSOLE_COMPONENT.FIRST_RAY_CUTOUT",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/first_ray_cutout.png",
        group: "shellModifications",
        footSelectionOptions: footSelectionOptions,
        selectOptions: [
            {
                value: "firstRay",
                title: "First Ray"
            },
            {
                value: "mpj1",
                title: "MPJ1"
            }
        ],
        form: insoleComponentsForms.firstRayCutout
    },
    {
        title: "Flanges",
        translationKey: "INSOLE_COMPONENT.FLANGES",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/flanges.png",
        group: "shellModifications",
        footSelectionOptions: footSelectionOptions,
        medialLateralType: "multiple",
        selectOptions: [
            {
                value: "others",
                title: "Other"
            },
            {
                value: 5,
                title: "5 mm"
            },
            {
                value: 10,
                title: "10 mm"
            },
            {
                value: 15,
                title: "15 mm"
            },
            {
                value: 20,
                title: "20 mm"
            }
        ],
        form: insoleComponentsForms.flanges
    },
    {
        title: "Arch Modification",
        translationKey: "INSOLE_COMPONENT.ARCH_MODIFICATION",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/arch_modification.png",
        medialLateralType: "multiple",
        group: "shellModifications",
        footSelectionOptions: footSelectionOptions,
        selectOptions: [
            {
                value: "others",
                title: "Other"
            },
            {
                value: -3,
                title: "-3 mm"
            },
            {
                value: 0,
                title: "Per cast"
            },
            {
                value: +3,
                title: "+3 mm"
            }
        ],
        form: insoleComponentsForms.archModification
    },
    {
        title: "Arch Reinforcement",
        translationKey: "INSOLE_COMPONENT.ARCH_REINFORCEMENT",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/arch_reinforcement.png",
        group: "shellModifications",
        footSelectionOptions: footSelectionOptions,
        typeSelectOptions: [
            {
                value: "thick",
                title: "Thick"
            },
            {
                value: "narrow",
                title: "Narrow"
            }
        ],
        selectOptions: [
            {
                value: "others",
                title: "Others"
            },
            {
                value: 2,
                title: "2 mm",
            },
            {
                value: 3,
                title: "3 mm"
            },
            {
                value: 4,
                title: "4 mm"
            },
            {
                value: 5,
                title: "5 mm"
            }
        ],
        form: insoleComponentsForms.archReinforcement
    },
    {
        title: "Morton's extension",
        translationKey: "INSOLE_COMPONENT.MORTONS_EXTENSION",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/mortons_extension.png",
        group: "shellModifications",
        footSelectionOptions: footSelectionOptions,
        selectOptions: [
            {
                value: "others",
                title: "Others"
            },
            {
                value: 2,
                title: "2 mm",
            },
            {
                value: 3,
                title: "3 mm"
            },
            {
                value: 4,
                title: "4 mm"
            },
            {
                value: 5,
                title: "5 mm"
            }
        ],
        reversedBooleanOption: true,
        form: insoleComponentsForms.mortonsExtension
    },
    {
        title: "Heel cutout",
        translationKey: "INSOLE_COMPONENT.HEEL_CUTOUT",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/cutout.png",
        group: "shellModifications",
        footSelectionOptions: footSelectionOptions,
        form: insoleComponentsForms.cutout
    },
    {
        title: "Forefoot Posting",
        translationKey: "INSOLE_COMPONENT.FOREFOOT_POSTING",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/forefoot_posting.png",
        group: "postings",
        footSelectionOptions: footSelectionOptions,
        medialLateralType: "unique",
        selectOptions: [
            {
                value: "others",
                title: "Other"
            },
            {
                value: 1,
                title: "1 mm"
            },
            {
                value: 2,
                title: "2 mm"
            },
            {
                value: 3,
                title: "3 mm"
            },
            {
                value: 4,
                title: "4 mm"
            },
            {
                value: 5,
                title: "5 mm"
            },
            {
                value: 6,
                title: "6 mm"
            }
        ],
        form: insoleComponentsForms.forefootPosting
    },
    {
        title: "Reafoot Posting",
        translationKey: "INSOLE_COMPONENT.REARFOOT_POSTING",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/rearfoot_posting.png",
        medialLateralType: "unique",
        footSelectionOptions: footSelectionOptions,
        group: "postings",
        selectOptions: [
            {
                value: "others",
                title: "Other"
            },
            {
                value: 1,
                title: "1 mm"
            },
            {
                value: 2,
                title: "2 mm"
            },
            {
                value: 3,
                title: "3 mm"
            },
            {
                value: 4,
                title: "4 mm"
            },
            {
                value: 5,
                title: "5 mm"
            },
            {
                value: 6,
                title: "6 mm"
            }
        ],
        typeSelectOptions: [
            {
                value: "uShape",
                title: "U shape"
            },
            {
                value: "full",
                title: "Full"
            },
            {
                value: "lateralHalf",
                title: "Lateral half"
            },
            {
                value: "medialHalf",
                title: "Medial half"
            }
        ],
        form: insoleComponentsForms.rearfootPosting
    },
    {
        title: "Metatarsal pad",
        translationKey: "INSOLE_COMPONENT.METATARSAL_PAD",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/metatarsal_pad.png",
        group: "shellModifications",
        footSelectionOptions: footSelectionOptions,
        selectOptions: [
            {
                value: 'others',
                title: 'Other'
            },
            {
                value: 1,
                title: "1 mm"
            },
            {
                value: 2,
                title: "2 mm"
            },
            {
                value: 3,
                title: "3 mm"
            },
            {
                value: 4,
                title: "4 mm"
            },
        ],
        typeSelectOptions: [
            {
                value: "drop",
                title: "Drop"
            },
            {
                value: "fullbar",
                title: "Full bar"
            }
        ],
        form: insoleComponentsForms.metatarsalPad
    },
    {
        title: "Fascial Groove",
        translationKey: "INSOLE_COMPONENT.FASCIAL_GROOVE",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/fascial_groove.png",
        group: "shellModifications",
        footSelectionOptions: footSelectionOptions,
        form: insoleComponentsForms.fascialGroove
    },
    {
        title: "Styloid",
        translationKey: "INSOLE_COMPONENT.STYLOID",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/styloid.png",
        form: insoleComponentsForms.styloid,
        group: "shellModifications",
        footSelectionOptions: footSelectionOptions,
        selectOptions: [
            {
                value: 'others',
                title: 'Other'
            },
            {
                value: 1,
                title: "1 mm"
            },
            {
                value: 2,
                title: "2 mm"
            },
            {
                value: 3,
                title: "3 mm"
            },
            {
                value: 4,
                title: "4 mm"
            },
        ],
    },
    {
        title: "Navicular Depression",
        translationKey: "INSOLE_COMPONENT.NAVICULAR_DEPRESSION",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/navicular_depression.png",
        form: insoleComponentsForms.navicularDepression,
        group: "shellModifications",
        footSelectionOptions: footSelectionOptions,
        selectOptions: [
            {
                value: 'others',
                title: 'Other'
            },
            {
                value: 1,
                title: "1 mm"
            },
            {
                value: 2,
                title: "2 mm"
            },
            {
                value: 3,
                title: "3 mm"
            },
            {
                value: 4,
                title: "4 mm"
            },
        ],
    },
    {
        title: "Density reduction",
        translationKey: "INSOLE_COMPONENT.DENSITY_REDUCTION",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/reduction.png",
        group: "shellModifications",
        footSelectionOptions: footSelectionOptions,
        form: insoleComponentsForms.densityReduction
    },
    {
        title: "Heel lift",
        translationKey: "INSOLE_COMPONENT.HEEL_LIFT",
        imageUrl: "https://wikyscan-2021.s3.eu-west-1.amazonaws.com/images/insoleComponents/heel_lift.png",
        form: insoleComponentsForms.heelLift,
        group: "postings",
        footSelectionOptions: footSelectionOptions,
        typeSelectOptions: [
            {
                value: "uShape",
                title: "U shape"
            },
            {
                value: "full",
                title: "Full"
            }
        ],
        selectOptions: [
            {
                value: 'others',
                title: 'Other'
            },
            {
                value: 2,
                title: "2 mm"
            },
            {
                value: 4,
                title: "4 mm"
            },
            {
                value: 6,
                title: "6 mm"
            }
        ],
    },
]